import { render, staticRenderFns } from "./informationedit.vue?vue&type=template&id=5640702f&scoped=true&"
import script from "./informationedit.vue?vue&type=script&lang=js&"
export * from "./informationedit.vue?vue&type=script&lang=js&"
import style0 from "./informationedit.vue?vue&type=style&index=0&id=5640702f&lang=stylus&scoped=true&"
import style1 from "./informationedit.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5640702f",
  null
  
)

component.options.__file = "informationedit.vue"
export default component.exports